// extracted by mini-css-extract-plugin
export var banner = "_qe-0";
export var settingRow = "_qe-2";
export var titleIcon = "_qe-1";